"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const community_1 = require("@aurora/shared-types/community");
const asynchronous_local_storage_1 = require("asynchronous-local-storage");
const set_cookie_parser_1 = __importDefault(require("set-cookie-parser"));
const log_1 = require("../log");
const log = (0, log_1.getLog)(module);
/**
 * A helper class for context cookies.
 */
class ContextCookieHelper {
    /**
     * Set any cookies on the fetch response into the http context.
     * @param setCookieHeaderValue the value of the "set-cookie" response header
     */
    static setContextCookies(setCookieHeaderValue) {
        // parentFrameId is only set on external requests to LIA -- we only want to capture context cookies while one is active
        if ((setCookieHeaderValue === null || setCookieHeaderValue === void 0 ? void 0 : setCookieHeaderValue.length) > 0 && (asynchronous_local_storage_1.als === null || asynchronous_local_storage_1.als === void 0 ? void 0 : asynchronous_local_storage_1.als.get(community_1.ContextKeys.parentFrameId)) != null) {
            const cookies = asynchronous_local_storage_1.als.get(ContextCookieHelper.KEY);
            // only set the cookies once per request
            if (cookies == null) {
                const contextCookies = set_cookie_parser_1.default.splitCookiesString(setCookieHeaderValue);
                if ((contextCookies === null || contextCookies === void 0 ? void 0 : contextCookies.length) > 0) {
                    log.debug('Setting context cookies: %s', contextCookies);
                    asynchronous_local_storage_1.als.set(ContextCookieHelper.KEY, contextCookies);
                }
            }
        }
    }
    /**
     * Merge any context cookies with cookies set by Aurora into the 'set-cookie' header on the page response.
     */
    static setResponseCookies(response) {
        const contextCookieHeaders = asynchronous_local_storage_1.als.get(ContextCookieHelper.KEY);
        if ((contextCookieHeaders === null || contextCookieHeaders === void 0 ? void 0 : contextCookieHeaders.length) > 0) {
            let setCookieValues = [...contextCookieHeaders];
            const setCookieHeaderValue = response.getHeader('set-cookie');
            if (setCookieHeaderValue) {
                if (Array.isArray(setCookieHeaderValue)) {
                    setCookieValues = [...contextCookieHeaders, ...setCookieHeaderValue];
                }
                else {
                    setCookieValues.push(`${setCookieHeaderValue}`);
                }
            }
            log.debug('Setting context cookies in response: %s', setCookieValues);
            response.setHeader('set-cookie', setCookieValues);
            asynchronous_local_storage_1.als.set(ContextCookieHelper.KEY, []);
        }
    }
}
ContextCookieHelper.KEY = 'contextCookies';
exports.default = ContextCookieHelper;
//# sourceMappingURL=ContextCookieHelper.js.map